import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import Population from './components/pages/Population'
import Property from './components/pages/Property';
import Infrastructure from './components/pages/Infrastructure';

import './App.scss';
import Damage from './components/pages/Damage';
import CartoProvider from './carto/CartoProvider';

class App extends Component {
  hideDrawer = () => {
    [...document.getElementsByClassName('as-toolbar__actions')].forEach(elm => {
      elm.classList.remove('as-toolbar__actions--visible')
    })
  }

  render() {
    return (
      <Provider store={store}>
        <Router>
          <as-toolbar className="as-toolbar">
            <div className="as-toolbar__item as-title">
              <img src="ramp-logo-mitigate-hazards.png" alt="Logo" style={{ objectFit: 'contain', height: 36, marginRight: 'auto' }} />
            </div>
            <nav className="as-toolbar__actions">
              <ul>
                <li>
                  <NavLink to="/" exact className="as-toolbar__item" activeClassName="as-toolbar__item--active" onClick={this.hideDrawer}>Population</NavLink>
                </li>
                <li>
                  <NavLink to="property" className="as-toolbar__item" activeClassName="as-toolbar__item--active" onClick={this.hideDrawer}>Property</NavLink>
                </li>
                <li>
                  <NavLink to="infrastructure" className="as-toolbar__item" activeClassName="as-toolbar__item--active" onClick={this.hideDrawer}>Critical Infrastructure</NavLink>
                </li>
                <li>
                  <a href="http://mitigatehazards.com/Solano/Web/Spec/RAMP/#/"  className="as-toolbar__item">Municipal Water Infrastructure</a>
                </li>
                <li>
                  <NavLink to="damage" className="as-toolbar__item" activeClassName="as-toolbar__item--active" onClick={this.hideDrawer}>Damage Assessment</NavLink>
                </li>
                <li>
                  <a href="http://mitigatehazards.com/ramp-help/" target="_blank" rel="noopener noreferrer" className="as-toolbar__item">Help</a>
                </li>
              </ul>
            </nav>
          </as-toolbar>
          <nav className="as-tabs"></nav>
          <Switch>
            <Route exact path="/">
              <CartoProvider>
                <Population></Population>
              </CartoProvider>
            </Route>
            <Route exact path="/property">
              <CartoProvider>
                <Property></Property>
              </CartoProvider>
            </Route>
            <Route exact path="/infrastructure">
              <CartoProvider>
                <Infrastructure></Infrastructure>
              </CartoProvider>
            </Route>
            <Route exact path="/damage">
              <CartoProvider>
                <Damage></Damage>
              </CartoProvider>
            </Route>
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default App;
